import React, { Component } from 'react';
import { Field } from 'formik';
import styled from 'styled-components';

import InputField from '../Form/FormInputField';
import Input from '../Form/FormInput';
import Label from '../Form/FormLabel';
import Error from '../Form/FormError';

import Tooltip from '../Form/Tooltip';

class TextInputTooltip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltipVisible: false,
    }
  }

  handleTouchStart = (event) => {
    // console.log('handleTouchStart event', event);
    this.setState({tooltipVisible: !this.state.tooltipVisible}, () => {
      // console.log('handleTouchStart', this.state.tooltipVisible);
    });
  }
  handleTouchEnd = (event) => {
    // console.log('handleTouchEnd event', event);
    this.setState({tooltipVisible: false}, () => {
      // console.log('handleTouchEnd', this.state.tooltipVisible);
    });
  }

  handleMouseEnter = (event) => {
    // console.log('handleMouseEnter event', event);
    this.setState({tooltipVisible: true}, () => {
      // console.log('handleMouseEnter', this.state.tooltipVisible);
    });
  }
  handleMouseLeave = (event) => { 
    // console.log('handleMouseLeave event', event);
    this.setState({tooltipVisible: false}, () => {
      // console.log('handleMouseLeave', this.state.tooltipVisible);
    });
  }

  handleKeyPress = (event) => {
    let keyCode = event.keyCode || event.charCode;
    if (keyCode === 32 || keyCode === 13) {
      this.setState({tooltipVisible: !this.state.tooltipVisible}, () => {
        // console.log('handleKeyPress', this.state.tooltipVisible);
      });
    }
  }

  render() {
    const {name, label, icon, companyLogo, companyAlt, message, messageTitle, ...rest} = this.props;
    return (
      <Field
        name={name}
        render={({ field, form }) => {
          const error = form.touched[name] && form.errors[name];
          const valid = form.touched[name] && form.errors[name] === undefined && form.initialValues[name] !== form.values[name]
          return (
            <InputField>
              <Label htmlFor={name}>{label}</Label>
              <InputGroup>
                <Input aria-describedby="info-tooltip" error={error} valid={valid} {...field} {...rest} />
                <InputAddon>
                  <Tooltip
                    icon={icon}
                    backgroundColor='#e3e3e3'
                    companyLogo={companyLogo} 
                    companyAlt={companyAlt} 
                    message={message}
                    messageTitle={messageTitle}
                    tooltipVisible={this.state.tooltipVisible}
                    handleMouseEnter={this.handleMouseEnter}
                    handleMouseLeave={this.handleMouseLeave}
                    handleKeyPress={this.handleKeyPress} 
                    handleTouchStart={this.handleTouchStart}
                    handleTouchEnd={this.handleTouchEnd}/>
                </InputAddon>
              </InputGroup>
              {form.errors[name] && form.touched[name] && (
                <Error error={error}>{form.errors[name]}</Error>
              )}
            </InputField>
          );
        }}
      />
    )
  }
} 

const InputAddon = styled.div`
  display: flex;
  position: relative;
`;

const InputGroup = styled.div`
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  font-size: 1rem;
  font-family: ${props => props.fontFamily ? props.fontFamily : '"Roboto", "Helvetica", "Arial", sans-serif'};
  line-height: 1.1875em;
`

export default TextInputTooltip;


// WEBPACK FOOTER //
// ./src/components/Form/TextInputTooltip.js